import { Button, Typography } from "@mui/material";
import SelectInput from "components/forms/SelectInput";
import TextInput from "components/forms/TextInput";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { countryOptions } from "services/geo/countries";
import { provinceOptions } from "services/geo/provines";
import { stateOptions } from "services/geo/states";
import { useAppSelector } from "store/hooks";
import { checkout } from "services/checkout";
import { useBackendError, useTotalTreeWeights } from "services/hooks";
import { formatter } from "services/misc";
import { PRICE, PRICE_DIRECT, PRICE_LIFETIME } from "services/config";

const Form = (props:any) => {  
  const { customTreesAmount } = props;
  const [ busy, setBusy ] = useState(false);
  const [ selectedCountry, setSelectedCountry ] = useState<string | null>(null);
  const { user, jwt } = useAppSelector((state) => state.app);
  const { years, selection } = useAppSelector((state) => state.wizard);
  const { handleRequestError } = useBackendError();
  const calculation = useTotalTreeWeights();

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue
  } = useForm();

  useEffect(() => {
    if(user && user.profile) {
      setValue("firstName", user.profile.firstName);
      setValue("lastName", user.profile.lastName);
      setValue("country", user.profile.country);
      setValue("address_1", user.profile.address_1);
      setValue("address_2", user.profile.address_2);
      setValue("zip", user.profile.zip);
      setTimeout(() => {
        setValue("state", user.profile.state);
      },300);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[user]);

  const onSubmit = async (form) => {
    setBusy(true);
    try {
      const payload = {
        quantity: calculation.totalTrees || customTreesAmount,
        offset: calculation.carbonTonnes || 0,
        years,
        ...(customTreesAmount ? { direct: true } : {}),
        ...form
      };
      const response = await checkout(payload,jwt!);
      sessionStorage.setItem("cb_checkout_Y", years.toString());
      sessionStorage.setItem("cb_checkout_S", JSON.stringify(selection));
      window.location.replace(response.url);
      /*
      window.open(
        response.url,
        '_blank'
      );
      */
      setBusy(false);
    } catch(err) {
      handleRequestError(err);
      setBusy(false);
    }
  };

  const watchCountry = watch("country", false);

  useEffect(() => {
    setSelectedCountry(watchCountry);
    setValue("state", "");
  },[selectedCountry, setValue, watchCountry]);

  let price = (years < 50 ? PRICE : PRICE_LIFETIME) * calculation.totalTrees * years;
  if(customTreesAmount) {
    price = PRICE_DIRECT * customTreesAmount;
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Typography variant="body2" textTransform="uppercase" color="#000" fontWeight={700}>
        Customer Information
      </Typography>
      <Typography variant="caption" color="#777" className="d-block mb-3 mt-1">
        Please complete the following form to continue.
      </Typography>
      <TextInput
        control={control}
        name="firstName" 
        label="First Name"
        errors={errors}
        rules={{
          required: "This field is required",
        }}
      />
      <TextInput
        control={control}
        name="lastName" 
        label="Last Name"
        errors={errors}
        rules={{
          required: "This field is required",
        }}
      />
      <SelectInput
        control={control}
        name="country" 
        label="Country"
        errors={errors}
        rules={{
          required: "This field is required",
        }}
        options={countryOptions}
      />
      <TextInput
        control={control}
        name="address_1" 
        label="Address Line 1"
        errors={errors}
        rules={{
          required: "This field is required",
        }}
      />
      <TextInput
        control={control}
        name="address_2" 
        label="Address Line 2"
        autoFocus={false}
        errors={errors}
      />

      {selectedCountry === "CA" ? (
        <SelectInput
          control={control}
          defaultValue=""
          name="state" 
          label="Province"
          errors={errors}
          rules={{
            required: "This field is required",
          }}
          options={provinceOptions}
        />
      ) : selectedCountry === "US" ? (
        <SelectInput
          control={control}
          defaultValue=""
          name="state" 
          label="State"
          errors={errors}
          rules={{
            required: "This field is required",
          }}
          options={stateOptions}
        />
      ) : null}

      <TextInput
        control={control}
        name="zip" 
        label={selectedCountry === "CA" ? "Postal Code" : "ZIP Code"}
        errors={errors}
        rules={{
          required: "This field is required",
        }}
      />
      
      <Button
        variant="contained"
        color="primary"
        fullWidth
        disableElevation
        type="submit"
        disabled={busy || !user}
      >
        Checkout &mdash; {customTreesAmount ? customTreesAmount : calculation.totalTrees} Trees for {
          formatter.format(
            price
          )
        }
      </Button>
    </form>
  );
};
export default Form;
